import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CreateCaseComponent } from './create-case/create-case.component';
import { ExistingCaseComponent } from './existing-case/existing-case.component';
import { WrongRouteComponent } from './wrong-route/wrong-route.component';

const routes: Routes = [
	{ path: 'home', pathMatch: 'full', component: HomeComponent},
	//{ path: 'home/:loc', pathMatch: 'full', component: HomeComponent},
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'create-case', pathMatch: 'full', component: CreateCaseComponent },
  { path: 'update-case', pathMatch: 'full', component: ExistingCaseComponent },
	//{ path: '**', redirectTo: '/home', pathMatch: 'full'}
  { path: 'page-not-found', component: WrongRouteComponent },
  { path: '**', component: WrongRouteComponent },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
 
})
export class AppRoutingModule { }
